import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import UpcomingFairsAvailability from './upcoming-fairs-availability';
import { SimpleLoadingComponent } from '../../utils/apollo';

const query = gql`
  query UpcomingFairsAvailability($id: String!, $fromDate: OrdinalDate, $distance: String, $numSchoolsWithinProximity: Int!) {
    viewer {
      id
      highSchoolsWithCollegeFairsWithinProximity(
        id: $id,
        numSchoolsWithinProximity: $numSchoolsWithinProximity,
        distance: $distance,
        fromDate: $fromDate
      ) {
        distance {
          text
        }
        toSchool {
          id
          name
          general {
            field_hs_na_nces_id
          }
          naviance {
            field_hs_na_nguid
            field_hs_elna_phone
          }
          address {
            field_hs_elna_location_latlon {
              latitude
              longitude
            }
            field_hs_elna_address_line1
            field_hs_elna_city
            field_hs_elna_state_latest
            field_hs_na_country_name
          }
          repVisitsAccount {
            id
            schoolTimezone
            collegeFairsPrimaryContact {
              id
              mail
              field_first_name
              field_last_name
            }
          }
          collegeFairs(first: 25, fromDate: $fromDate) {
            edges {
              node {
                id
                name,
                date,
                startTime,
                startISOTime
                endTime,
                endISOTime
                rsvpDeadline,
                maxColleges,
                currentColleges,
                numberOfExpectedStudents,
                cost,
                notes,
                webInstructions,
                emailInstructions,
                autoConfirmRequests,
                status,
                attending
              }
            }
          }
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ id, fromDate, distance, numSchoolsWithinProximity }) => ({
    variables: {
      id,
      fromDate,
      distance,
      numSchoolsWithinProximity,
    },
  }),
});

export default SimpleLoadingComponent(graphqlData)(UpcomingFairsAvailability);
